// main starting page of master mapping 
import React, { Component } from "react";
import { Form, Row, Col } from "react-bootstrap";
import DataGrid from "./DataGrid";
import _ from "lodash";
import HisService from "services/admin/masters/hisService";
import Spinner from "components/shared/Spinner";
import { handleRefresh, toggleChangehandlerNew, getCurrentSlug } from "utils/masterHelpers";
const serviceObj = new HisService();
class List extends Component {
  constructor(props) {
    super(props);
    this.toggleChangehandler = toggleChangehandlerNew.bind(this);
    this.handleRefresh = handleRefresh.bind(this);
    this.getCurrentSlug = getCurrentSlug.bind(this);
    this.state = {
      loadingTable: false,
      refreshToken: Date.now(),
      //datatable states
      filtering: true,
      columns: [
        { title: "HIS Masters Mapping", field: "name" },
      ],
      actions: [{
        icon: 'settings',
        tooltip: "Manage Mapping",
        onClick: this.handleNavigation,
      }],
      recordsMainFilter: { "field": "is_deleted", "type": "int", "value": 0, "operator": "eq" },
      customRowClickHandler: this.handleNavigation, // navigation upon row click
      paging: false
    };
  }

  handleNavigation = (event, rowData) => {
    this.props.history.push("/admin/master/" + this.getCurrentSlug() + "/manage-mapping/"  + rowData.id);
  }

  handlePagingData = (query) => {
    this.setState({
      loadingTable: true
    });
    return new Promise((resolve, reject) => {
      this.setState({ pageSize: query.pageSize }, () => {
        serviceObj.getAllHis().then((response) => {
          this.setState({
            loadingTable: false
          })
          resolve({
            data: response.items
          });
        }).catch(e => {
          this.setState({
            loadingTable: false
          })
        });
      });
    });
  }
  render() {
    const { loadingTable } = this.state;
    return (
      <>
        {loadingTable ? <Spinner /> : null}
        <div className="form-wrap mt-3">
          <div className="form-group">
            <Form.Group as={Row}>
              <Col sm={12}>
                <DataGrid
                  actions={this.state.actions}
                  columns={this.state.columns}
                  dataHandler={this.handlePagingData}
                  pageSize={this.state.pageSize}
                  filtering={this.state.filtering}
                  refreshToken={this.state.refreshToken}
                  customRowClickHandler={this.state.customRowClickHandler}
                  paging={this.state.paging}
                ></DataGrid>
              </Col>
            </Form.Group>
          </div>
        </div>
      </>
    );
  }

}
export default List;
